// Home.js (fixed: use shared currentLang from context)
import { useContext, useState } from 'react';
import { Container, Button, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../contexts/AppContext';
import '../styles/Home.css';
import LanguageIcon from '@mui/icons-material/Language';

function Home() {
  const navigate = useNavigate();
  const { carParkInfo, currentLang, setCurrentLang } = useContext(AppContext); // Use shared currentLang
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const translations = {
    'zh-tw': {
      paymentMethods: '付款方式',
      alipay: '支付寶',
      wechat: '微信支付',
      visa: 'Visa',
      mastercard: 'Mastercard',
      start: '開始'
    },
    'zh-cn': {
      paymentMethods: '付款方式',
      alipay: '支付宝',
      wechat: '微信支付',
      visa: 'Visa',
      mastercard: 'Mastercard',
      start: '开始'
    },
    'en': {
      paymentMethods: 'Payment methods',
      alipay: 'Alipay',
      wechat: 'WeChat',
      visa: 'Visa',
      mastercard: 'Mastercard',
      start: 'Start'
    }
  };

  const getTranslation = (key) => translations[currentLang][key] || translations['en'][key];

  // Get car park name based on current language
  const getCarParkName = () => {
    switch (currentLang) {
      case 'zh-tw':
        return carParkInfo.carParkNameTw || carParkInfo.carParkNameEn;
      case 'zh-cn':
        return carParkInfo.carParkNameCn || carParkInfo.carParkNameEn;
      case 'en':
      default:
        return carParkInfo.carParkNameEn || '';
    }
  };

  const getCurrentLangLabel = () => {
    switch (currentLang) {
      case 'zh-tw':
        return '繁中';
      case 'zh-cn':
        return '简中';
      case 'en':
        return 'Eng';
      default:
        return 'Eng';
    }
  };

  const getOtherLanguages = () => {
    const allLanguages = [
      { code: 'zh-tw', label: '繁中' },
      { code: 'zh-cn', label: '简中' },
      { code: 'en', label: 'Eng' }
    ];
    return allLanguages.filter(lang => lang.code !== currentLang);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLangChange = (langCode) => {
    setCurrentLang(langCode);
    handleClose();
  };

  const renderLangSelector = () => (
    <div style={{ 
      position: 'absolute', 
      top: '50px', 
      fontSize: '36px',
      right: '30px', 
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center'
    }}>
      <IconButton 
        onClick={handleClick}
        style={{
          color: '#4a4a4aff', // Black globe as in image
          padding: 0,
        }}
      >
        <LanguageIcon />
      </IconButton>
      <span style={{ marginLeft: '3px', color: '#504f4fff', fontSize: '25px' }}>
        {getCurrentLangLabel()}
      </span>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        {getOtherLanguages().map((lang) => (
          <MenuItem 
            key={lang.code} 
            onClick={() => handleLangChange(lang.code)}
            style={{
              fontSize: '14px',
              color: '#666',
            }}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );

  const titleContent = (
    <>
      {getCarParkName()}
      <br />
      {getTranslation('paymentMethods')}
    </>
  );

  return (
    <div className="home-page" style={{ position: 'relative' }}>
      {renderLangSelector()}
      {/* <pre style={{ fontSize: 24 }}>{JSON.stringify({isLoggedIn, carParkInfo}, null, 2)}</pre>    */}
      <img src="/wilsonparking.jpg" alt="Wilson Parking Logo" className="home-logo" />
      <Container className="home-container" maxWidth="sm">
        <Typography className="home-title" variant="h5">
          {titleContent}
        </Typography>        

        <div className="home-payment-icons">
          <div className="home-payment-icons-row">
            <div className="home-payment-icon">
              <img src="/images/payment/alipay.png" alt="Alipay" />
              <div className="home-payment-label">{getTranslation('alipay')}</div>
            </div>
            <div className="home-payment-icon">
              <img src="/images/payment/wechat.png" alt="WeChat" />
              <div className="home-payment-label">{getTranslation('wechat')}</div>
            </div>
            {/* <div className="home-payment-icon">
              <img src="/images/payment/visa.png" alt="Visa" />
              <div className="home-payment-label">{getTranslation('visa')}</div>
            </div>
            <div className="home-payment-icon">              
              <img src="/images/payment/mastercard.png" alt="Mastercard" />
              <div className="home-payment-label">{getTranslation('mastercard')}</div>
            </div> */}
          </div>
        </div>

        <Button
          className="home-button"
          onClick={() => navigate('/enquiry')}
          aria-label={getTranslation('start')}
        >
          {getTranslation('start')}
        </Button>
      </Container>
    </div>
  );
}

export default Home;